import { render, staticRenderFns } from "./ClientLayout.vue?vue&type=template&id=0d198a24&"
import script from "./ClientLayout.vue?vue&type=script&lang=js&"
export * from "./ClientLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports